module.exports = __webpack_public_path__ + "img/arrow-down.e4e0ec67.svg";